export const defaultButtonProps = {
  role: 'button',
  tabIndex: 0,
}
